import { Component, OnInit, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { forkJoin, Subject } from 'rxjs';
import { HttpService } from 'src/app/services/http.service';
import { Pays } from '../../bo/pays';
import { ProfilConfigurationSaisieDonneesAnalyse } from '../../bo/profilConfigurationSaisieDonneesAnalyse';
import { ProprieteAffichee } from '../../bo/proprieteAffichee';
import { Region } from '../../bo/region';
import { Site } from '../../bo/site';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { SiteModaleComponent } from '../site-modale/site-modale.component';


@Component({
  selector: 'app-site',
  templateUrl: './site.component.html',
  styleUrls: ['./site.component.scss'],
  standalone: false
})
export class SiteComponent implements OnInit {
  modaleAjout: BsModalRef;
  tabSites = signal<Site[]>([]);
  proprietesAfficheesSites: ProprieteAffichee[] = [];
  erreurRecuperation = signal(false);
  listeModifiee = new Subject<void>();
  pays = signal<Pays[]>([]);

  constructor(private readonly modalService: BsModalService, private readonly http: HttpService, private readonly fonctionsService: FonctionsService, private readonly translate: TranslateService) {
    this.proprietesAfficheesSites = new Site().getProprietesAffichees();
    this.modalService.onHide.observers = [];
    this.modalService.onHide.subscribe((val: any) => {
      // siteId == -1 quand on clique sur "Ajouter" et que l'on ferme
      if (this.modaleAjout && this.modaleAjout.content && this.modaleAjout.content.site.siteId != -1 && val != "esc") {
        var siteId = this.tabSites().findIndex(p => p.siteId == this.modaleAjout.content.site.siteId);
        // Modif
        if (siteId != -1) {
          const updated = [...this.tabSites()];
          Object.assign(updated[siteId], this.modaleAjout.content.site);
          this.tabSites.set(updated);
        } else {
          this.tabSites.set([...this.tabSites(), this.modaleAjout.content.site]);
        }
        this.listeModifiee.next();
        this.modaleAjout = null;
      }
    });
  }

  ngOnInit() {
    this.erreurRecuperation.set(false);
    this.fonctionsService.loading_screen(true);
    var sites = this.http.get<Site[]>('Sites');
    var paysPromise = this.http.get<Pays[]>('Countries');

    forkJoin([sites, paysPromise]).subscribe(resultat => {
      this.pays.set(resultat[1]);

      const sitesWithPays = resultat[0].map(site => {
        site.pays = resultat[1].find(p => p.paysId == site.paysId);
        return site;
      });
      this.tabSites.set(sitesWithPays);
      this.fonctionsService.loading_screen(false);
    }, () => {
      this.erreurRecuperation.set(true);
      this.fonctionsService.loading_screen(false);
    });
  }

  ReLoadSites() {
    this.http.get<Site[]>('Sites').subscribe(resultat => {
      const sitesWithPays = resultat.map(site => {
        site.pays = this.pays().find(p => p.paysId == site.paysId);
        return site;
      });
      this.tabSites.set(sitesWithPays);
    })
  }

  ouvrirModaleAjout() {
    this.fonctionsService.loading_screen(true);
    let regions = this.http.get<Region[]>('Regions/GetByCurrentUser');
    let profils = this.http.get<ProfilConfigurationSaisieDonneesAnalyse[]>('Profiles');
    forkJoin([regions, profils]).subscribe(resultats => {

      this.fonctionsService.loading_screen(false);
      resultats[0] = resultats[0].filter(p => p.isActif == true); //Ne pas afficher les régions inactives
      var initialState = {
        tabRegions: resultats[0],
        tabPays: this.pays(),
        estModif: false,
        tabProfils: resultats[1]
      };
      this.modaleAjout = this.modalService.show(SiteModaleComponent, { backdrop: true, ignoreBackdropClick: true, keyboard: false, initialState });
      (this.modaleAjout.content as SiteModaleComponent).submitEvent.subscribe(() => {
        this.ReLoadSites();
      });
    }, () => {
      this.translate.get('GLOBAL.ERREUR_RECUP_DONNEES').subscribe(trad => {
        this.fonctionsService.launch_toast(false, false, trad)
      });
      this.fonctionsService.loading_screen(false);
    });
  }

  ouvrirModale(site: Site) {
    this.fonctionsService.loading_screen(true);
    let regions = this.http.get<Region[]>('Regions/GetByCurrentUser');
    let pays = this.http.get<Pays[]>('Countries');
    let siteSelectionnee = this.http.get<Site>('Sites/' + site.siteId);
    let profils = this.http.get<ProfilConfigurationSaisieDonneesAnalyse[]>('Profiles');


    forkJoin([regions, pays, siteSelectionnee, profils]).subscribe(resultats => {
      this.fonctionsService.loading_screen(false);
      resultats[0] = resultats[0].filter(p => p.isActif == true); //Ne pas afficher les régions inactives

      var initialState = {
        tabRegions: resultats[0],
        tabPays: resultats[1],
        estModif: true,
        site: resultats[2],
        paysSelectionne: signal(resultats[1].find(o => o.paysId == site.paysId)),
        paysBackup: resultats[1].find(o => o.paysId == site.paysId),
        regionSelectionnee: signal(resultats[0].find(o => o.regionId == site.regionId)),
        regionBackup: resultats[0].find(o => o.regionId == site.regionId),
        tabProfils: resultats[3]
      };
      this.modaleAjout = this.modalService.show(SiteModaleComponent, { backdrop: true, ignoreBackdropClick: true, keyboard: false, initialState });
    }, () => {
      this.translate.get('GLOBAL.ERREUR_RECUP_DONNEES').subscribe(trad => {
        this.fonctionsService.launch_toast(false, false, trad)
      });
      this.fonctionsService.loading_screen(false);
    });
  }
}
